import { isDepositRejectionError } from "~/api/error";
import { logger } from "~/services/logger";

import { type CreatePreOrdersArgs } from "../requests";

/**
 * A deposit rejection means the till showed a fee the server does not agree
 * with, so it is logged with the basket's ids for diagnosis. A warning, not
 * an error: the server already reports the refusal to Sentry. Ids only,
 * never end-user data.
 */
export function reportPreOrderDepositRejection(
  error: unknown,
  basket: CreatePreOrdersArgs["basket"]
): void {
  if (!isDepositRejectionError(error)) return;

  logger.warn("Collect pre-order refused over its deposit", {
    error_code: error.body.code,
    product_ids: basket.map((item) => item.id),
    module_ids: basket.map((item) => item.moduleId),
    rejected_product_ids: error.body.productIds ?? []
  });
}
